<template>
  <div class="h-screen w-full">
    <div class="vx-row">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center my-base"
    >
      <div class="w-full text-center">
        <h3 class="mb-3">{{ $t("errors.404.Title") }} 🕵🏻‍♀️</h3>
        <p class="mb-5 text-base">
          {{ $t("errors.404.Text") }}
        </p>
        <vs-button
          :to="token ? '/hives' : '/login'"
          color="warning"
        >
          <span class="text-white">{{ $t("errors.404.Button") }}</span>
        </vs-button>
      </div>
      <div class="w-full text-center px-4">
        <img
          src="@/assets/images/pages/404.png"
          alt="404 Image"
          class="mx-auto max-w-full"
        />
      </div>
    </div>
  </div>
  </div>
</template>
<script type="text/javascript">
export default {
  data () {
    return {
      token: localStorage.getItem('token')
    }
  }
}
</script>